export default {"src":"/_next/static/media/add-orange.9f024972.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};